import {Impression} from "../../components/Impressum";
import styled from "styled-components";
import {BaseLayout} from "../../layouts/Base";

const Container = styled.div`
  width: 50%;
  margin: 5vh auto 10vh;
`

export const ImpressionPage = () => {
    return (
        <BaseLayout>
            <Container>
                <Impression/>
            </Container>
        </BaseLayout>
    )
}